export const numbersAndLettersRegex = /^[A-Za-z0-9]*$/
